import * as React from "react";
import { Form, Input, Checkbox, Select } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { AttributeFormConstants } from "../../../common/Constants";
import { IFormConfigQualifierAttribute } from "../../../service/formconfiguration/FormConfigQualifierAttribute";

export interface State {
  labelVisibleCheckboxDisabled: boolean;
}

export interface Props {
  getFieldDecorator: any;
  translate: any;
  formConfigQualifierAttribute?: IFormConfigQualifierAttribute;
  readOnly?: boolean;
  setFieldsValue: (obj: Object, callback?: Function | undefined) => void;
}

export default class FormConfigQualifierAttributeForm extends React.Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);
    this.state = {
      labelVisibleCheckboxDisabled: this.isAttributeReadOnlyReference()
    };
  }

  isAttributeReadOnlyReference() {
    const { formConfigQualifierAttribute } = this.props;
    const attributeType = formConfigQualifierAttribute?.attribute.type;
    return (
      attributeType === AttributeFormConstants.TYPE_VALUES.READ_ONLY_REFERENCA
    );
  }

  getLabelVisibleCheckboxDefaultValue() {
    const { formConfigQualifierAttribute } = this.props;

    const labelVisibleCheckboxDisabled = this.isAttributeReadOnlyReference();

    if (labelVisibleCheckboxDisabled) {
      return true;
    }
    return formConfigQualifierAttribute?.labelVisible;
  }

  onTypeSelect(value) {
    const { formConfigQualifierAttribute, setFieldsValue } = this.props;
    if (value === AttributeFormConstants.TYPE_VALUES.READ_ONLY_REFERENCA) {
      this.setState({
        labelVisibleCheckboxDisabled: true
      });
      setFieldsValue({ labelVisible: true });
    } else {
      this.setState({
        labelVisibleCheckboxDisabled: false
      });
      setFieldsValue({
        labelVisible: formConfigQualifierAttribute?.labelVisible
      });
    }
  }

  render() {
    const {
      getFieldDecorator,
      translate,
      formConfigQualifierAttribute,
      readOnly
    } = this.props;

    const { labelVisibleCheckboxDisabled } = this.state;

    return (
      <Form>
        {
          <Form.Item label={translate("attribute_form.code")}>
            {getFieldDecorator(AttributeFormConstants.Fields.CODE, {
              initialValue: formConfigQualifierAttribute?.attributeCode,
              rules: [
                {
                  required: true,
                  message: translate("attribute_form.required_message", {
                    field: translate("attribute_form.code")
                  })
                }
              ]
            })(
              <Input
                readOnly={
                  formConfigQualifierAttribute || readOnly ? true : false
                }
              />
            )}
          </Form.Item>
        }
        <Form.Item label={translate("attribute_form.attribute_name")}>
          {getFieldDecorator(AttributeFormConstants.Fields.ATTRIBUTE_NAME, {
            initialValue:
              formConfigQualifierAttribute?.attribute?.attributeName,
            rules: [
              {
                required: true,
                message: translate("attribute_form.required_message", {
                  field: translate("attribute_form.attribute_name")
                })
              }
            ]
          })(<Input readOnly={readOnly} />)}
        </Form.Item>
        <Form.Item label={translate("attribute_form.description")}>
          {getFieldDecorator(AttributeFormConstants.Fields.DESCRIPTION, {
            initialValue: formConfigQualifierAttribute?.attribute?.description,
            rules: [
              {
                required: false,
                message: translate("attribute_form.required_message", {
                  field: translate("attribute_form.description")
                })
              }
            ]
          })(
            <TextArea
              readOnly={readOnly}
              autoSize={{ minRows: 3 }}
              maxLength={
                AttributeFormConstants.VALIDATION_RULES.DESCRIPTION_MAX_LENGTH
              }
            />
          )}
        </Form.Item>
        <Form.Item label={translate("attribute_form.type")}>
          {getFieldDecorator(AttributeFormConstants.Fields.TYPE, {
            initialValue: formConfigQualifierAttribute?.attribute?.type,
            rules: [
              {
                required: true,
                message: translate("attribute_form.required_message", {
                  field: translate("attribute_form.type")
                })
              }
            ]
          })(
            <Select
              disabled={readOnly}
              showSearch={true}
              placeholder={translate("attribute_form.select_qualifier")}
              style={{ width: "100%" }}
              allowClear
              notFoundContent={translate("search.no_data")}
              onSelect={(value) => {
                this.onTypeSelect(value);
              }}
            >
              {AttributeFormConstants.TYPE_VALUES.ALL_VALUES_AS_ARRAY.map(
                (item) => (
                  <Select.Option key={item} value={item}>
                    {item}
                  </Select.Option>
                )
              )}
            </Select>
          )}
        </Form.Item>
        <Form.Item label={translate("attribute_form.sql_validation")}>
          {getFieldDecorator(AttributeFormConstants.Fields.SQL_VALIDATION, {
            initialValue:
              formConfigQualifierAttribute?.attribute?.sqlValidation,
            rules: [
              {
                required: false,
                message: translate("attribute_form.required_message", {
                  field: translate("attribute_form.sql_validation")
                })
              }
            ]
          })(
            <TextArea
              readOnly={readOnly}
              autoSize={{ minRows: 3 }}
              maxLength={
                AttributeFormConstants.VALIDATION_RULES
                  .SQL_VALIDATION_MAX_LENGTH
              }
            />
          )}
        </Form.Item>
        <Form.Item label={translate("attribute_form.method_validation")}>
          {getFieldDecorator(AttributeFormConstants.Fields.METHOD_VALIDATION, {
            initialValue:
              formConfigQualifierAttribute?.attribute?.methodValidation,
            rules: [
              {
                required: false,
                message: translate("attribute_form.required_message", {
                  field: translate("attribute_form.method_validation")
                })
              }
            ]
          })(
            <TextArea
              readOnly={readOnly}
              autoSize={{ minRows: 3 }}
              maxLength={
                AttributeFormConstants.VALIDATION_RULES
                  .FIJA_VALIDATION_MAX_LENGTH
              }
            />
          )}
        </Form.Item>
        {formConfigQualifierAttribute && (
          <Form.Item label={translate("attribute_form.required")}>
            {getFieldDecorator(AttributeFormConstants.Fields.REQUIRED, {
              valuePropName: "checked",
              initialValue: formConfigQualifierAttribute
                ? formConfigQualifierAttribute.required
                : false,
              rules: [
                {
                  required: true,
                  message: translate("attribute_form.required_message", {
                    field: translate("attribute_form.required")
                  })
                }
              ]
            })(<Checkbox disabled={readOnly} />)}
          </Form.Item>
        )}
        {formConfigQualifierAttribute && (
          <Form.Item label={translate("attribute_form.validation")}>
            {getFieldDecorator(AttributeFormConstants.Fields.VALIDATION, {
              valuePropName: "checked",
              initialValue: formConfigQualifierAttribute
                ? formConfigQualifierAttribute.validation
                : false,
              rules: [
                {
                  required: true,
                  message: translate("attribute_form.required_message", {
                    field: translate("attribute_form.validation")
                  })
                }
              ]
            })(<Checkbox disabled={readOnly} />)}
          </Form.Item>
        )}
        {formConfigQualifierAttribute && (
          <Form.Item
            label={translate("attribute_form.order_number_insert_display")}
          >
            {getFieldDecorator(
              AttributeFormConstants.Fields.ORDER_NUMBER_INSERT_DISPLAY,
              {
                initialValue:
                  formConfigQualifierAttribute?.orderNumberInsertDisplay,
                rules: [
                  {
                    required: true,
                    message: translate("attribute_form.required_message", {
                      field: translate(
                        "attribute_form.order_number_insert_display"
                      )
                    })
                  }
                ]
              }
            )(<Input readOnly={readOnly} />)}
          </Form.Item>
        )}
        {formConfigQualifierAttribute && (
          <Form.Item
            label={translate("attribute_form.qualifier_attribute_name")}
          >
            {getFieldDecorator(
              AttributeFormConstants.Fields.QUALIFIER_ATTRIBUTE_NAME,
              {
                initialValue: formConfigQualifierAttribute?.name,
                rules: [
                  {
                    required: false,
                    message: translate("attribute_form.required_message", {
                      field: translate(
                        "attribute_form.qualifier_attribute_name"
                      )
                    })
                  }
                ]
              }
            )(<Input readOnly={readOnly} />)}
          </Form.Item>
        )}
        {formConfigQualifierAttribute && (
          <Form.Item label={translate("attribute_form.label_visible")}>
            {getFieldDecorator(AttributeFormConstants.Fields.LABEL_VISIBLE, {
              valuePropName: "checked",
              initialValue: this.getLabelVisibleCheckboxDefaultValue(),
              rules: [
                {
                  required: false,
                  message: translate("attribute_form.required_message", {
                    field: translate("attribute_form.label_visible")
                  })
                }
              ]
            })(
              <Checkbox disabled={readOnly || labelVisibleCheckboxDisabled} />
            )}
          </Form.Item>
        )}
        {formConfigQualifierAttribute && (
          <Form.Item label={translate("qualifier_form.visible_public")}>
            {getFieldDecorator(AttributeFormConstants.Fields.VISIBLE, {
              valuePropName: "checked",
              initialValue: formConfigQualifierAttribute
                ? formConfigQualifierAttribute.visible
                : false,
              rules: [
                {
                  required: true,
                  message: translate("attribute_form.required_message", {
                    field: translate("attribute_form.visible_public")
                  })
                }
              ]
            })(<Checkbox disabled={readOnly} />)}
          </Form.Item>
        )}
      </Form>
    );
  }
}
